
import React, { useState } from 'react';

const OrderSAV = ({ messages = [], onAddMessage }) => {
  const [expanded, setExpanded] = useState(false);
  const [newMsg, setNewMsg] = useState("");

  const handleAdd = () => {
    if (newMsg.trim()) {
      onAddMessage(newMsg.trim());
      setNewMsg("");
    }
  };

  return (
    <div className="order-sav mt-4">
      <div className="sav-header d-flex justify-content-between align-items-center bg-dark text-white p-2" style={{cursor:'pointer'}} onClick={() => setExpanded(!expanded)}>
        <span className="fw-bold">SAV (PRIVÉ)</span>
        <button className="btn btn-sm text-white border-light" onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
          {expanded ? '-' : '+'}
        </button>
      </div>
      {expanded && (
        <div className="sav-body border p-3 bg-light">
          {messages.length === 0 ? (
            <p className="text-muted small">Aucun message.</p>
          ) : (
            <div className="sav-messages mb-3" style={{maxHeight:'200px', overflowY:'auto'}}>
              {messages.map((m, i) => (
                <div key={i} className="bg-white border rounded p-2 mb-2 small">
                  <div className="fw-bold text-primary">{m.author || 'Staff'} - {new Date(m.date).toLocaleString()}</div>
                  <div>{m.text}</div>
                </div>
              ))}
            </div>
          )}
          <div className="d-flex gap-2">
            <input type="text" className="form-control form-control-sm" value={newMsg} onChange={e=>setNewMsg(e.target.value)} placeholder="MESSAGES..." onKeyDown={e => e.key === 'Enter' && handleAdd()} />
            <button className="btn btn-sm btn-dark" onClick={handleAdd}>Ajouter</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSAV;
